import { atom } from 'jotai';
import { unwrap } from 'jotai/utils';
import { playerTeamsOptionsAtom } from '@/atoms/queries/players';
import { teamsOptionsAtom } from '@/atoms/queries/teams';
import { NumberOption } from '@/types/generic';
import { SectionAtomMap } from '@/types/section';
import { getAtomForSection } from '@/utils/atoms/section';
import { filtersAtom } from '../filter';

const teamSectionMapAtom = atom<SectionAtomMap<NumberOption[]>>(() => ({
  player: playerTeamsOptionsAtom,
  team: teamsOptionsAtom,
  dataLocker: teamsOptionsAtom,
  game: teamsOptionsAtom,
}));

export const teamOptionsAtom = atom(getAtomForSection(teamSectionMapAtom));

const unwrappedTeamOptions = unwrap(teamOptionsAtom, prev => prev || []);
export const selectedTeamsAtom = atom(get => {
  const teamOptions = get(unwrappedTeamOptions);
  const selectedTeamIds = get(filtersAtom).teamIds;

  return teamOptions.filter(({ value }) => selectedTeamIds.includes(value));
});
